const iOSRegex = /iPhone|iPad|iPod/i;
const mobileDeviceRegex = /Android|BlackBerry|IEMobile|WPDesktop/i;

export const isIos = () => matchUserAgent(iOSRegex);
export const isMobileDevice = () => isIos() || matchUserAgent(mobileDeviceRegex);

const matchUserAgent = (regexp: RegExp) => regexp.exec(window.navigator.userAgent);
